import { createContext, useContext } from 'react'

interface GymTheme {
  primaryColor: string | null
  secondaryColor: string | null
}

/**
 * The gym app's own accent, the same as the HeroUI theme's primary. Staff see
 * this, never the gym's brand colours: a brand green or beige across the whole
 * desk app made it hard to read. The brand colours still style the member app.
 */
export const APP_PRIMARY = '#BD4627'

export const GymThemeContext = createContext<GymTheme>({
  primaryColor: null,
  secondaryColor: null,
})

export function useGymThemeContext(): GymTheme {
  return useContext(GymThemeContext)
}
